import { render, staticRenderFns } from "./Homes.vue?vue&type=template&id=a604b85a&scoped=true&"
import script from "./Homes.vue?vue&type=script&lang=js&"
export * from "./Homes.vue?vue&type=script&lang=js&"
import style0 from "./Homes.vue?vue&type=style&index=0&id=a604b85a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a604b85a",
  null
  
)

export default component.exports